export default "__VITE_PUBLIC_ASSET__0e132b64__"